export default __webpack_public_path__ + "1b0204a42d7f98c6cb87ca4682269a17.svg";